import noop from 'lodash/noop';
import { MODE_TRENDS } from '@store/trends/constants';

export const defaultProps = {
  isSharing: false,
  applyFilter: noop,
  selectCompareMode: noop,
  compareMode: 0,
  disableSummaryCards: false,
  drilldown: [],
  filters: [],
  updateInterval: noop,
  drillUp: noop,
  toggleNewComparisonDashboard: noop,
  data: {},
  loading: false,
  error: false,
  metrics: [],
  selectedMetric: '',
  deleteAllNonSavedFilterBars: noop,
  toggleModal: noop,
  features: {},
  sharingState: {},
  collapseStatus: {},
  sharedTabs: [],
  deleteSharedTab: noop,
  presetFid: null,
  mode: MODE_TRENDS,
  selectedMetricChart: noop,
};
